import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { QueryClientProvider } from '@tanstack/react-query';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import './styles.css';
import { App } from './App';
import { watchForErrors } from './diagnostics';
import { watchClicks } from './pageEvents';
import { createQueryClient } from './queryClient';
import { theme } from './theme';

watchForErrors();
watchClicks();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={createQueryClient()}>
      <MantineProvider theme={theme}>
        <Notifications position="bottom-center" />
        <App />
      </MantineProvider>
    </QueryClientProvider>
  </StrictMode>,
);
